<template>
  <div>
    <template>
      {{ $t('this_message_was_replied_ads', { ad_id: adData.ad_id }) }}
    </template>
    <div v-if="adData && adData.ads_context_data && adData.ads_context_data.ad_title">
      AD Title : {{ adData.ads_context_data.ad_title }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    adData: {}
  },
  data() {
    return {
      item: null,
      isError: false,
      errorMessages: ''
    }
  },
  async mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/ReplyAds.vue